import { render, staticRenderFns } from "./DataProtection.vue?vue&type=template&id=2d847fc7&scoped=true"
import script from "./DataProtection.vue?vue&type=script&lang=js"
export * from "./DataProtection.vue?vue&type=script&lang=js"
import style0 from "./DataProtection.vue?vue&type=style&index=0&id=2d847fc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d847fc7",
  null
  
)

export default component.exports